import React, { useEffect, useReducer, useState } from 'react';
import { Button, Tab, Tabs } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import {
  HS_TELEPHONY_PORT_NONE,
  HS_TELEPHONY_TCP_PORT,
  HS_TELEPHONY_TLS_PORT,
  telephonyPort,
  telephonySecondaryPort,
} from '../../../../../../constants/HotelServicesConst';
import CustomActiveInactiveRadio from '../../../../../../shared/form-controls/custom-active-inactive-radio/Custom-Active-Inactive-Radio';
import CustomSelect from '../../../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { formDataValidate } from '../../../../../../utils/formUtils';
import {
  fetchTelephonyConfigurator,
  fetchTelephonyEpbxList,
  isTelephonyConfigsLoadedSelector,
  telephonyConfigsSelector,
  telephonyEpbxSelector,
} from '../../../../configurationSlice';
import { createTelephonyConfig } from '../../../../../../utils/IntegrationsAPIUtils';
import { notificationManager } from '../../../../../../utils/NotificationUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../../utils/loaderSlice';
import { ENVIRONMENT } from '../../../../../../env/Configurations';

const TelephonyConfigurator = ({ selectedHotel, showLoader = () => {} }) => {
  const dispatch = useDispatch();
  const telephonyEpbx = useSelector(telephonyEpbxSelector);
  const telephonyConfigs = useSelector(telephonyConfigsSelector);
  const isTelephonyConfigsLoaded = useSelector(isTelephonyConfigsLoadedSelector);
  const [tabValue, setTabValue] = useState(0);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    epbxStatus: {
      value: 'active',
      fieldName: 'EPBX (Electronic Automatic Private Branch Exchange)',
      errors: {},
      validations: ['required'],
    },
    epbx: {
      value: '',
      fieldName: 'EPBX',
      errors: {},
      validations: ['required'],
    },
    avayaSessionManagerPrimary: {
      value: 'active',
      fieldName: 'Avaya Session Manager (Primary)',
      errors: {},
      validations: [],
    },
    avayaSessionManagerPrimaryIpAddress: {
      value: '',
      fieldName: 'IP Address',
      errors: {},
      validations: [],
    },
    avayaSessionManagerSecondary: {
      value: 'active',
      fieldName: 'Avaya Session Manager (Secondary)',
      errors: {},
      validations: [],
    },
    avayaSessionManagerSecondaryIpAddress: {
      value: '',
      fieldName: 'IP Address',
      errors: {},
      validations: [],
    },
    avayaSessionManagerSecurityModule: {
      value: 'active',
      fieldName: 'Avaya Session Manager Security Module',
      errors: {},
      validations: [],
    },
    avayaSessionManagerSecurityModuleIpAddress: {
      value: '',
      fieldName: 'IP Address',
      errors: {},
      validations: [],
    },
    sbcemsServerM1Primary: {
      value: 'active',
      fieldName: 'SBC EMS Server M1 (Primary)',
      errors: {},
      validations: [],
    },
    sbcemsServerM1PrimaryIpAddress: {
      value: '',
      fieldName: 'IP Address',
      errors: {},
      validations: [],
    },
    sbcemsServerM1Secondary: {
      value: 'active',
      fieldName: 'SBC EMS Server M1 (Secondary)',
      errors: {},
      validations: [],
    },
    sbcemsServerM1SecondaryIpAddress: {
      value: '',
      fieldName: 'IP Address',
      errors: {},
      validations: [],
    },
    SBCA1: {
      value: 'active',
      fieldName: 'SBC A1',
      errors: {},
      validations: [],
    },
    SBCA1IpAddress: {
      value: '',
      fieldName: 'IP Address',
      errors: {},
      validations: [],
    },
    port: {
      value: HS_TELEPHONY_TCP_PORT,
      fieldName: 'Primary Port',
      errors: {},
      validations: [],
    },
    secondaryPort: {
      value: HS_TELEPHONY_PORT_NONE,
      fieldName: 'Secondary Port',
      errors: {},
      validations: [],
    },
    sipDomainOfTheSetupDomainName: {
      value: '',
      fieldName: 'Domain name',
      errors: {},
      validations: [],
    },
  });

  useEffect(() => {
    if (!isTelephonyConfigsLoaded) {
      dispatch(fetchTelephonyEpbxList());
      if (selectedHotel) dispatch(fetchTelephonyConfigurator(selectedHotel));
    }
  }, [selectedHotel, isTelephonyConfigsLoaded]);

  useEffect(() => {
    const currFormData = { ...formData };
    currFormData.epbxStatus.value = telephonyConfigs?.epbx?.active ? 'active' : 'inactive';
    currFormData.epbx.value = telephonyConfigs?.epbx?.value || '';
    currFormData.avayaSessionManagerPrimary.value = telephonyConfigs?.sessionManager?.active
      ? 'active'
      : 'inactive';
    currFormData.avayaSessionManagerPrimaryIpAddress.value =
      telephonyConfigs?.sessionManager?.value || '';
    currFormData.avayaSessionManagerPrimaryIpAddress.validations = telephonyConfigs?.sessionManager
      ?.active
      ? ['required']
      : [];
    currFormData.avayaSessionManagerSecondary.value = telephonyConfigs?.sessionManagerSecondary
      ?.active
      ? 'active'
      : 'inactive';
    currFormData.avayaSessionManagerSecondaryIpAddress.value =
      telephonyConfigs?.sessionManagerSecondary?.value || '';
    currFormData.avayaSessionManagerSecondaryIpAddress.validations = telephonyConfigs
      ?.sessionManagerSecondary?.active
      ? ['required']
      : [];
    currFormData.avayaSessionManagerSecurityModule.value = telephonyConfigs?.securityModule?.active
      ? 'active'
      : 'inactive';
    currFormData.avayaSessionManagerSecurityModuleIpAddress.value =
      telephonyConfigs?.securityModule?.value || '';
    currFormData.avayaSessionManagerSecurityModuleIpAddress.validations = telephonyConfigs
      ?.securityModule?.active
      ? ['required']
      : [];
    currFormData.sbcemsServerM1Primary.value = telephonyConfigs?.sbcEmsServer?.active
      ? 'active'
      : 'inactive';
    currFormData.sbcemsServerM1PrimaryIpAddress.value = telephonyConfigs?.sbcEmsServer?.value || '';
    currFormData.sbcemsServerM1PrimaryIpAddress.validations = telephonyConfigs?.sbcEmsServer?.active
      ? ['required']
      : [];
    currFormData.sbcemsServerM1Secondary.value = telephonyConfigs?.sbcEmsServerSecondary?.active
      ? 'active'
      : 'inactive';
    currFormData.sbcemsServerM1SecondaryIpAddress.value =
      telephonyConfigs?.sbcEmsServerSecondary?.value || '';
    currFormData.sbcemsServerM1SecondaryIpAddress.validations = telephonyConfigs
      ?.sbcEmsServerSecondary?.active
      ? ['required']
      : [];
    currFormData.SBCA1.value = telephonyConfigs?.sbcA1?.active ? 'active' : 'inactive';
    currFormData.SBCA1IpAddress.value = telephonyConfigs?.sbcA1?.value || '';
    currFormData.SBCA1IpAddress.validations = telephonyConfigs?.sbcA1?.active ? ['required'] : [];
    currFormData.port.value = telephonyConfigs?.portTLS
      ? HS_TELEPHONY_TLS_PORT
      : HS_TELEPHONY_TCP_PORT;
    currFormData.secondaryPort.value = telephonyConfigs?.portTLSSecondary;
    currFormData.sipDomainOfTheSetupDomainName.value = telephonyConfigs?.sipDomain || '';
    setFormData(currFormData);
  }, [telephonyConfigs]);

  const validate = (isFieldsUpdated) => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, isFieldsUpdated ? updatedFields : isFieldsUpdated);
    if (isFieldsUpdated) setFormData(updatedFields);
    return isValid;
  };
  const onChangeRadio = (type, e) => {
    const currField = { ...formData[type] };
    const epbx = { ...formData.epbx };
    const avayaSessionManagerPrimaryIpAddress = {
      ...formData.avayaSessionManagerPrimaryIpAddress,
    };
    const avayaSessionManagerSecondaryIpAddress = {
      ...formData.avayaSessionManagerSecondaryIpAddress,
    };
    const avayaSessionManagerSecurityModuleIpAddress = {
      ...formData.avayaSessionManagerSecurityModuleIpAddress,
    };
    const sbcemsServerM1PrimaryIpAddress = {
      ...formData.sbcemsServerM1PrimaryIpAddress,
    };
    const sbcemsServerM1SecondaryIpAddress = {
      ...formData.sbcemsServerM1SecondaryIpAddress,
    };
    const SBCA1IpAddress = { ...formData.SBCA1IpAddress };
    const sipDomainOfTheSetupDomainName = {
      ...formData.sipDomainOfTheSetupDomainName,
    };
    switch (type) {
      case 'epbxStatus':
        currField.value = e.value;
        if (e.value === 'inactive') {
          epbx.value = '';
          avayaSessionManagerPrimaryIpAddress.validations = [];
          avayaSessionManagerPrimaryIpAddress.value = '';
          avayaSessionManagerSecondaryIpAddress.validations = [];
          avayaSessionManagerSecondaryIpAddress.value = '';
          avayaSessionManagerSecurityModuleIpAddress.validations = [];
          avayaSessionManagerSecurityModuleIpAddress.value = '';
          sbcemsServerM1PrimaryIpAddress.validations = [];
          sbcemsServerM1PrimaryIpAddress.value = '';
          sbcemsServerM1SecondaryIpAddress.validations = [];
          sbcemsServerM1SecondaryIpAddress.value = '';
          SBCA1IpAddress.validations = [];
          SBCA1IpAddress.value = '';
          sipDomainOfTheSetupDomainName.validations = [];
          sipDomainOfTheSetupDomainName.value = '';
        }
        break;
      case 'avayaSessionManagerPrimary':
        currField.value = e.value;
        avayaSessionManagerPrimaryIpAddress.validations =
          e.value === 'inactive' ? [] : ['required'];
        avayaSessionManagerPrimaryIpAddress.value = '';
        break;
      case 'avayaSessionManagerSecondary':
        currField.value = e.value;
        avayaSessionManagerSecondaryIpAddress.validations =
          e.value === 'inactive' ? [] : ['required'];
        avayaSessionManagerSecondaryIpAddress.value = '';
        break;
      case 'avayaSessionManagerSecurityModule':
        currField.value = e.value;
        avayaSessionManagerSecurityModuleIpAddress.validations =
          e.value === 'inactive' ? [] : ['required'];
        avayaSessionManagerSecurityModuleIpAddress.value = '';
        break;
      case 'sbcemsServerM1Primary':
        currField.value = e.value;
        sbcemsServerM1PrimaryIpAddress.validations = e.value === 'inactive' ? [] : ['required'];
        sbcemsServerM1PrimaryIpAddress.value = '';
        break;
      case 'sbcemsServerM1Secondary':
        currField.value = e.value;
        sbcemsServerM1SecondaryIpAddress.validations = e.value === 'inactive' ? [] : ['required'];
        sbcemsServerM1SecondaryIpAddress.value = '';
        break;
      case 'SBCA1':
        currField.value = e.value;
        SBCA1IpAddress.validations = e.value === 'inactive' ? [] : ['required'];
        SBCA1IpAddress.value = '';
        break;
      default:
        break;
    }
    setFormData({
      [type]: currField,
      epbx,
      avayaSessionManagerPrimaryIpAddress,
      avayaSessionManagerSecondaryIpAddress,
      avayaSessionManagerSecurityModuleIpAddress,
      sbcemsServerM1PrimaryIpAddress,
      sbcemsServerM1SecondaryIpAddress,
      SBCA1IpAddress,
      sipDomainOfTheSetupDomainName,
    });
  };

  const onChangeEpbx = (e) => {
    const avayaSessionManagerPrimaryIpAddress = {
      ...formData.avayaSessionManagerPrimaryIpAddress,
    };
    const avayaSessionManagerSecondaryIpAddress = {
      ...formData.avayaSessionManagerSecondaryIpAddress,
    };
    const avayaSessionManagerSecurityModuleIpAddress = {
      ...formData.avayaSessionManagerSecurityModuleIpAddress,
    };
    const sbcemsServerM1PrimaryIpAddress = {
      ...formData.sbcemsServerM1PrimaryIpAddress,
    };
    const sbcemsServerM1SecondaryIpAddress = {
      ...formData.sbcemsServerM1SecondaryIpAddress,
    };
    const SBCA1IpAddress = { ...formData.SBCA1IpAddress };
    const sipDomainOfTheSetupDomainName = {
      ...formData.sipDomainOfTheSetupDomainName,
    };
    const avayaSessionManagerPrimary = {
      ...formData.avayaSessionManagerPrimary,
    };
    const avayaSessionManagerSecondary = {
      ...formData.avayaSessionManagerSecondary,
    };
    const avayaSessionManagerSecurityModule = {
      ...formData.avayaSessionManagerSecurityModule,
    };
    const sbcemsServerM1Primary = { ...formData.sbcemsServerM1Primary };
    const sbcemsServerM1Secondary = { ...formData.sbcemsServerM1Secondary };
    const SBCA1 = { ...formData.SBCA1 };
    avayaSessionManagerPrimaryIpAddress.validations = ['required'];
    avayaSessionManagerSecondaryIpAddress.validations = ['required'];
    avayaSessionManagerSecurityModuleIpAddress.validations = ['required'];
    sbcemsServerM1PrimaryIpAddress.validations = ['required'];
    sbcemsServerM1SecondaryIpAddress.validations = ['required'];
    SBCA1IpAddress.validations = ['required'];
    sipDomainOfTheSetupDomainName.validations = ['required'];
    avayaSessionManagerPrimary.value = 'active';
    avayaSessionManagerSecondary.value = 'active';
    avayaSessionManagerSecurityModule.value = 'active';
    sbcemsServerM1Primary.value = 'active';
    sbcemsServerM1Secondary.value = 'active';
    SBCA1.value = 'active';
    setFormData({
      epbx: e,
      avayaSessionManagerPrimaryIpAddress,
      avayaSessionManagerSecondaryIpAddress,
      avayaSessionManagerSecurityModuleIpAddress,
      sbcemsServerM1PrimaryIpAddress,
      sbcemsServerM1SecondaryIpAddress,
      SBCA1IpAddress,
      sipDomainOfTheSetupDomainName,
      avayaSessionManagerPrimary,
      avayaSessionManagerSecondary,
      avayaSessionManagerSecurityModule,
      sbcemsServerM1Primary,
      sbcemsServerM1Secondary,
      SBCA1,
    });
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    } else {
      setTabValue(newValue);
    }
  };

  const disableSave = () => {
    if (formData.epbxStatus.value === 'inactive') return true;
    if (formData.epbx.value === '') return true;
    const isValid = validate(false);
    return !isValid;
  };

  const onSubmit = async (e) => {
    try {
      e.preventDefault();
      dispatch(stepUpLoaderCount());
      const isValid = validate(true);
      if (!isValid) return false;
      const payload = {
        epbx: {
          active: formData.epbxStatus.value === 'active' ? true : false,
          value: formData.epbx.value,
        },
        hotelId: selectedHotel,
        portTLS: formData.port.value === HS_TELEPHONY_TCP_PORT ? false : true,
        portTLSSecondary: formData.secondaryPort.value,
        sbcA1: {
          active: formData.SBCA1.value === 'active' ? true : false,
          value: formData.SBCA1IpAddress.value,
        },
        sbcEmsServer: {
          active: formData.sbcemsServerM1Primary.value === 'active' ? true : false,
          value: formData.sbcemsServerM1PrimaryIpAddress.value,
        },
        sbcEmsServerSecondary: {
          active: formData.sbcemsServerM1Secondary.value === 'active' ? true : false,
          value: formData.sbcemsServerM1SecondaryIpAddress.value,
        },
        securityModule: {
          active: formData.avayaSessionManagerSecurityModule.value === 'active',
          value: formData.avayaSessionManagerSecurityModuleIpAddress.value,
        },
        sessionManager: {
          active: formData.avayaSessionManagerPrimary.value === 'active',
          value: formData.avayaSessionManagerPrimaryIpAddress.value,
        },
        sessionManagerSecondary: {
          active: formData.avayaSessionManagerSecondary.value === 'active',
          value: formData.avayaSessionManagerSecondaryIpAddress.value,
        },
        sipDomain: formData.sipDomainOfTheSetupDomainName.value,
      };
      await createTelephonyConfig(payload);
      dispatch(fetchTelephonyConfigurator(selectedHotel));
      notificationManager('success', 'Telephony configurator details updated successfully');
    } catch (error) {
      if (ENVIRONMENT === 'dev') {
        console.log(error?.message);
      }

      notificationManager('danger', 'Unable to update telephony configurator');
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };
  return (
    <form onSubmit={onSubmit} noValidate>
      <div className='col-12 hotel-service-tab-section'>
        <div className='col col-xl-6'>
          <Tabs
            value={tabValue}
            variant='fullWidth'
            indicatorColor='primary'
            onChange={handleTabChange}
            aria-label='roomTypes-add-tabs'
            textColor='primary'
            className='property-tabs'
          >
            <Tab label='Configurable features' />
          </Tabs>
        </div>
      </div>
      {tabValue === 0 && (
        <div className='mx-4'>
          <div className='hotel-service-section'>
            <div className='hotel-service-subtitle'>
              {formData.epbxStatus.fieldName}
              <CustomActiveInactiveRadio
                item={formData.epbxStatus}
                handleRadioButton={(e) => {
                  onChangeRadio('epbxStatus', e);
                }}
              />
              {formData.epbxStatus.value === 'active' && (
                <div className='col-md-5'>
                  <CustomSelect
                    item={formData.epbx}
                    handleInputChange={(e) => {
                      onChangeEpbx(e);
                      setFormData({ epbx: e });
                    }}
                    hideNullOption={true}
                    valueField='id'
                    labelField='label'
                    options={telephonyEpbx}
                    labelPrefix='Select'
                  />
                </div>
              )}
            </div>
          </div>
          {formData.epbx.value === 'AVAYA' && formData.epbxStatus.value === 'active' && (
            <>
              <div className='hotel-service-section'>
                <div className='hotel-service-subtitle'>
                  {formData.avayaSessionManagerPrimary.fieldName}
                  <CustomActiveInactiveRadio
                    item={formData.avayaSessionManagerPrimary}
                    handleRadioButton={(e) => {
                      onChangeRadio('avayaSessionManagerPrimary', e);
                    }}
                  />
                  {formData.avayaSessionManagerPrimary.value === 'active' && (
                    <div className='col-md-5'>
                      <CustomTextField
                        item={formData.avayaSessionManagerPrimaryIpAddress}
                        handleInputChange={(e) => {
                          setFormData({
                            avayaSessionManagerPrimaryIpAddress: e,
                          });
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className='hotel-service-section'>
                <div className='hotel-service-subtitle'>
                  {formData.avayaSessionManagerSecondary.fieldName}
                  <CustomActiveInactiveRadio
                    item={formData.avayaSessionManagerSecondary}
                    handleRadioButton={(e) => {
                      onChangeRadio('avayaSessionManagerSecondary', e);
                    }}
                  />
                  {formData.avayaSessionManagerSecondary.value === 'active' && (
                    <div className='col-md-5'>
                      <CustomTextField
                        item={formData.avayaSessionManagerSecondaryIpAddress}
                        handleInputChange={(e) => {
                          setFormData({
                            avayaSessionManagerSecondaryIpAddress: e,
                          });
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className='hotel-service-section'>
                <div className='hotel-service-subtitle'>
                  {formData.avayaSessionManagerSecurityModule.fieldName}
                  <CustomActiveInactiveRadio
                    item={formData.avayaSessionManagerSecurityModule}
                    handleRadioButton={(e) => {
                      onChangeRadio('avayaSessionManagerSecurityModule', e);
                    }}
                  />
                  {formData.avayaSessionManagerSecurityModule.value === 'active' && (
                    <div className='col-md-5'>
                      <CustomTextField
                        item={formData.avayaSessionManagerSecurityModuleIpAddress}
                        handleInputChange={(e) => {
                          setFormData({
                            avayaSessionManagerSecurityModuleIpAddress: e,
                          });
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className='hotel-service-section'>
                <div className='hotel-service-subtitle'>
                  {formData.sbcemsServerM1Primary.fieldName}
                  <CustomActiveInactiveRadio
                    item={formData.sbcemsServerM1Primary}
                    handleRadioButton={(e) => {
                      onChangeRadio('sbcemsServerM1Primary', e);
                    }}
                  />
                  {formData.sbcemsServerM1Primary.value === 'active' && (
                    <div className='col-md-5'>
                      <CustomTextField
                        item={formData.sbcemsServerM1PrimaryIpAddress}
                        handleInputChange={(e) => {
                          setFormData({ sbcemsServerM1PrimaryIpAddress: e });
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className='hotel-service-section'>
                <div className='hotel-service-subtitle'>
                  {formData.sbcemsServerM1Secondary.fieldName}
                  <CustomActiveInactiveRadio
                    item={formData.sbcemsServerM1Secondary}
                    handleRadioButton={(e) => {
                      onChangeRadio('sbcemsServerM1Secondary', e);
                    }}
                  />
                  {formData.sbcemsServerM1Secondary.value === 'active' && (
                    <div className='col-md-5'>
                      <CustomTextField
                        item={formData.sbcemsServerM1SecondaryIpAddress}
                        handleInputChange={(e) => {
                          setFormData({
                            sbcemsServerM1SecondaryIpAddress: e,
                          });
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className='hotel-service-section'>
                <div className='hotel-service-subtitle'>
                  {formData.SBCA1.fieldName}
                  <CustomActiveInactiveRadio
                    item={formData.SBCA1}
                    handleRadioButton={(e) => {
                      onChangeRadio('SBCA1', e);
                    }}
                  />
                  {formData.SBCA1.value === 'active' && (
                    <div className='col-md-5'>
                      <CustomTextField
                        item={formData.SBCA1IpAddress}
                        handleInputChange={(e) => {
                          setFormData({ SBCA1IpAddress: e });
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className='hotel-service-section'>
                <div className='hotel-service-subtitle'>
                  {formData.port.fieldName}
                  <CustomActiveInactiveRadio
                    item={formData.port}
                    handleRadioButton={(e) => {
                      setFormData({ port: e });
                    }}
                    options={telephonyPort}
                  />
                </div>
              </div>
              <div className='hotel-service-section'>
                <div className='hotel-service-subtitle'>
                  {formData.secondaryPort.fieldName}
                  <CustomActiveInactiveRadio
                    item={formData.secondaryPort}
                    handleRadioButton={(e) => {
                      setFormData({ secondaryPort: e });
                    }}
                    options={telephonySecondaryPort}
                  />
                </div>
              </div>
              <div className='hotel-service-section'>
                <div className='hotel-service-subtitle'>
                  SIP Domain of the setup
                  <div className='col-md-5'>
                    <CustomTextField
                      item={formData.sipDomainOfTheSetupDomainName}
                      handleInputChange={(e) => {
                        setFormData({ sipDomainOfTheSetupDomainName: e });
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
          <div className='row mt-auto px-4 w-100 pb-5'>
            <div className='col-md-12 mt-3  d-flex justify-content-start'>
              <Button
                variant='contained'
                type='submit'
                color='primary'
                size='large'
                disabled={disableSave()}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      )}
    </form>
  );
};

export default TelephonyConfigurator;
